// Resources
import API from "../helpers/API"

import { getParamsToCreateOrder } from "../helpers/OrderTools"

/**
 * Componente funcional para manipulacão dos dados de pedidos
 */
const OrderController = {
  insert(order, customer, orderType, scheduleOrder, isPixelInitialized = false, pixelEventId = null) {
    // Definindo os parametros
    let params = getParamsToCreateOrder(order, customer, isPixelInitialized, pixelEventId)
    if (orderType === "schedule") {
      params = {
        ...params,
        id_neighbourhood: customer.id_neighbourhood,
        st_approved: true,
      }

      return API.request("/v1/schedule/order", { ...params, scheduleOrder }, "POST")
    }

    // Só o /v1/order usa a trava por chave de checkout; PIX e agendamento seguem sem ela
    params.ds_order_key = order.ds_order_key
    return API.request("/v1/order", params, "POST", {}, 60000)
  },

  fetchOne(orderUid) {
    return API.request("/v1/order/one/" + orderUid, [], "GET", {}, 60000)
  },

  fetchProgress(uuid_order) {
    return API.request("/v1/order/progress/" + uuid_order, [], "GET")
  },

  fetchAllByCustomer(options = {}) {
    const { cursor, limit = 10 } = options
    return API.request("/v1/order/customer/website", { cursor, limit }, "GET")
  },

  countOrdersByCustomer(uuid_customer, endDate = null, startDate = null) {
    const params = { endDate, startDate }
    return API.request("/v1/order/customer/" + uuid_customer + "/count", params, "GET")
  },
}

export default OrderController
